export default function homePage(){
    $('.color-swatch-button').on('click', function(e) {
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected")
        e.preventDefault();
    });
}
